import { useState, useEffect } from 'react';
import { Accordion, AccordionDetails, FormControlLabel, Checkbox, IconButton, Tooltip, Button } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { daysOfWeek } from '../../constants';

interface ScheduleSelectorProps {
    pricing: any;
    expanded: boolean;
    setExpanded: (value: boolean) => void;
    onAddToCart: (arg0: any) => void;
}

const ScheduleSelector = ({ pricing, expanded, setExpanded, onAddToCart }: ScheduleSelectorProps) => {
    const [selectedDays, setSelectedDays] = useState({});
    const [addToCartDisabled, setAddToCartDisabled] = useState(false);

    useEffect(() => {
        const hasSelectedDay = Object.values(selectedDays).some(value => value);
        if (!hasSelectedDay && !addToCartDisabled) setAddToCartDisabled(true);
        else if (hasSelectedDay && addToCartDisabled) setAddToCartDisabled(false);
    }, [selectedDays])

    const handleCheckboxChange = (day: string, isChecked: boolean) => {
        setSelectedDays({ ...selectedDays, [day]: isChecked });
    };

    const handleAddToCartClick = () => {
        const selectedDaysArray = Object.entries(selectedDays).filter(([_key, value]) => value).map(([key]) => key);
        onAddToCart(selectedDaysArray);
    };

    return (
        <Accordion expanded={expanded} onChange={(_event, isExpanded) => setExpanded(isExpanded)} className="schedule-selector ptf-0">
            <AccordionDetails className="">
                <p className="p-info text-alignment pb-1">Choose Days <b>(MAX: {pricing.maxScheduleDays})</b></p>
                <div className="text-center content-item">
                    {Object.entries(daysOfWeek).map(([key, fullName]) => (
                        <FormControlLabel
                            key={key}
                            control={
                                <Checkbox
                                    disabled={!pricing[key]}
                                    onChange={(e) => handleCheckboxChange(key, e.target.checked)}
                                    sx={{
                                        paddingRight: '1px !important'
                                    }}
                                />
                            }
                            label={fullName.charAt(0).toUpperCase()}
                            sx={{
                                marginRight: '10px !important'
                            }}  
                        />
                    ))}
                    <Tooltip title={addToCartDisabled ? "Please select at least 1 day" : "Add selected days to Cart"} className="pt-3 btn-cart">
                        <span> {/* wrapping button with span is required to allow tooltip to show on disabled button */}
                            <Button className={addToCartDisabled ? "p-14" : "cursor-pointer p-14 btn-add-cart"} style={ addToCartDisabled ? { backgroundColor: 'gray', cursor: 'not-allowed', pointerEvents: 'all' } : {}} onClick={handleAddToCartClick} disabled={addToCartDisabled}>
                                <IconButton className="ptf-0 ptb-0">
                                    <AddShoppingCartIcon />
                                </IconButton>
                                Add to cart
                            </Button>
                        </span>
                    </Tooltip>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default ScheduleSelector;
